import React from "react";
import { cn } from "@/lib/utils";

export const SectionHeading = ({ eyebrow, title, description, align = "left", tone = "light", as: Tag = "h2", className }) => {
  const titleColor = tone === "dark" ? "text-cream" : "text-charcoal";
  const descColor = tone === "dark" ? "text-cream/65" : "text-[#8C857D]";
  return (
    <div className={cn("max-w-2xl", align === "center" && "mx-auto text-center", className)}>
      {eyebrow && (
        <div className={cn("mb-4 flex items-center gap-3", align === "center" && "justify-center")}>
          <span className="h-px w-8 bg-bordo" />
          <span className="font-mono text-xs uppercase tracking-[0.25em] text-bordo">{eyebrow}</span>
        </div>
      )}
      <Tag className={cn("font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[0.95]", titleColor)}>
        {title}
      </Tag>
      {description && (
        <p className={cn("mt-5 text-base sm:text-lg leading-relaxed", descColor)}>{description}</p>
      )}
    </div>
  );
};

export default SectionHeading;
